export default __webpack_public_path__ + "static/media/blog-1.effa4ec9.jpg";